export function getCurrentTime(){
   return new Date().getTime();
}